import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Button,
  makeStyles,
  Container,
  Divider,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  MenuItem,
  InputLabel,
  Switch
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import { Formik } from 'formik';
import { useAlert } from "react-alert";
import PageHeader from 'src/views/Common/PageHeader';
import { MaskeliyaBLERPEnum } from 'src/views/Common/MaskeliyaBLERPEnum/MaskeliyaBLERPEnum';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecordAndNew: {
    backgroundColor: "#FFBE00"
  },
  colorRecord: {
    backgroundColor: "green",
  },
  colorReject: {
    backgroundColor: "red",
  },
  colorApprove: {
    backgroundColor: "green",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const screenCode = 'EMPLOYEELEAVEFORM';

export default function EmployeeLeaveFormAddEdit(props) {
  const maskeliyaEnum = new MaskeliyaBLERPEnum();
  const [title, setTitle] = useState("Employee Leave Form")
  const classes = useStyles();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [leaveTypes, setLeaveTypes] = useState();
  const [employeeVerified, setEmployeeVerified] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [remainingLeave, setRemainingLeave] = useState(0);
  const [leaveFormData, setLeaveFormData] = useState({
    groupID: 0,
    factoryID: 0,
    leaveTypeID: 0,
    regNo: '',
    fromDate: '',
    toDate: '',
    date: '',
    coveringPerson: '',
    noOfDays: 0,
    isCoveringPerson: false,
    applyForID: 0,
    timeFrom: '',
    timeTo: '',
    reason: '',
    halfID: 0
  })

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isLeaveRequestApproveReject: false
  });
  let decryptedID = 0;
  const { employeeLeaveRequestID } = useParams();
  const navigate = useNavigate();

  const handleClick = () => {

    navigate('/app/employeeLeaveForm/listing');

  }

  const alert = useAlert();

  useEffect(() => {
    trackPromise(getGroupsForDropdown(), getPermission(), getleaveTypesForDropDown());
  }, []);

  useEffect(() => {
    decryptedID = atob(employeeLeaveRequestID.toString());
    if (decryptedID != 0) {
      trackPromise(getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(decryptedID));
    }
  }, []);

  useEffect(() => {
    if (leaveFormData.groupID != 0) {
      trackPromise(getFactoriesForDropDown());
    }
  }, [leaveFormData.groupID]);

  useEffect(() => {
    if (leaveFormData.regNo != '') {
      getEmployeeAvailability();
    }
  }, [leaveFormData.regNo]);

  useEffect(() => {
    if (leaveFormData.halfID == 1) {
      setLeaveFormData({
        ...leaveFormData,
        timeFrom: maskeliyaEnum.EmployeeLeaveFormMorningHalf.TimeFrom,
        timeTo: maskeliyaEnum.EmployeeLeaveFormMorningHalf.TimeTo
      })
    }
    else {
      setLeaveFormData({
        ...leaveFormData,
        timeFrom: maskeliyaEnum.EmployeeLeaveFormEveningHalf.TimeFrom,
        timeTo: maskeliyaEnum.EmployeeLeaveFormEveningHalf.TimeTo
      })
    }
  }, [leaveFormData.halfID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITEMPLOYEELEAVEFORM');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isLeaveRequestApproveReject = permissions.find(p => p.permissionCode === 'VIEWLEAVEREQUESTAPPROVEREJECT');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isLeaveRequestApproveReject: isLeaveRequestApproveReject !== undefined
    });

    setLeaveFormData({
      ...leaveFormData,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }
  async function getFactoriesForDropDown() {
    const factory = await services.getFactoryByGroupID(leaveFormData.groupID);
    setFactories(factory);
  }

  async function getleaveTypesForDropDown() {
    const leaveTypes = await services.getleaveTypes();
    setLeaveTypes(leaveTypes);
  }

  async function getEmployeeAvailability() {
    if (leaveFormData.groupID != 0 && leaveFormData.factoryID != 0 && leaveFormData.regNo != "") {
      const verify = await services.getEmployeeAvailability(leaveFormData.groupID, leaveFormData.factoryID, leaveFormData.regNo);
      if (verify.statusCode == "Success") {
        setEmployeeVerified(true);
      }
      else {
        setEmployeeVerified(false);
      }
    }
  }

  async function getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(employeeLeaveRequestID) {
    let response = await services.getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(employeeLeaveRequestID);
    setTitle("Edit Employee Leave Form");
    let model = {
      groupID: response.groupID,
      factoryID: response.factoryID,
      leaveTypeID: response.leaveTypeID,
      regNo: response.registrationNumber,
      applyForID: response.applyForID,
      fromDate: new Date(response.fromDate).toISOString().slice(0, 10),
      toDate: new Date(response.toDate).toISOString().slice(0, 10),
      noOfDays: response.noOfDays,
      reason: response.reason,
      isCoveringPerson: response.isCoveringPerson,
      coveringPerson: response.coveringPerson,
      timeFrom: response.timeFrom,
      timeTo: response.timeTo,
      date: new Date(response.date).toISOString().slice(0, 10),
      halfID: response.halfID
    }
    setLeaveFormData(model);
    setIsUpdate(true);
    setEmployeeVerified(false);

    getEmployeeRemainingLeaveValue(model.leaveTypeID, model.regNo);
  }

  async function getEmployeeRemainingLeaveValue(leaveTypeID, regNo) {

    let remaining = await services.getEmployeeRemainingLeaveValue(leaveTypeID, regNo)
    if (remaining.statusCode == "Success") {
      setRemainingLeave(remaining.data.remainingLeaveValue)
    }
  }

  async function submitApplication() {
    let model = {
      employeeLeaveRequestID: 0,
      groupID: parseInt(leaveFormData.groupID),
      factoryID: parseInt(leaveFormData.factoryID),
      registrationNumber: leaveFormData.regNo,
      leaveTypeID: parseInt(leaveFormData.leaveTypeID),
      applyForID: parseInt(leaveFormData.applyForID),
      fromDate: leaveFormData.fromDate,
      toDate: leaveFormData.toDate,
      noOfDays: parseInt(leaveFormData.noOfDays),
      reason: leaveFormData.reason,
      isCoveringPerson: leaveFormData.isCoveringPerson,
      coveringPerson: leaveFormData.isCoveringPerson ? leaveFormData.coveringPerson : "",
      timeFrom: leaveFormData.timeFrom.toString(),
      timeTo: leaveFormData.timeTo.toString(),
      date: leaveFormData.date.toString(),
      halfID: parseInt(leaveFormData.halfID),
      CreatedBy: parseInt(tokenService.getUserIDFromToken())
    }

    const response = await services.SaveLeaveFormDetails(model);
    if (response.statusCode == "Success") {
      alert.success(response.message);
      clearData();
      navigate('/app/employeeLeaveForm/listing');
    }
    else {
      alert.error(response.message);
    }
  }

  async function updateEmployeeLeaveDetails() {
    let model = {
      groupID: parseInt(leaveFormData.groupID),
      factoryID: parseInt(leaveFormData.factoryID),
      employeeLeaveRequestID: parseInt(atob(employeeLeaveRequestID)),
      registrationNumber: leaveFormData.regNo,
      leaveTypeID: parseInt(leaveFormData.leaveTypeID),
      applyForID: parseInt(leaveFormData.applyForID),
      fromDate: leaveFormData.applyForID == 2 ? null : leaveFormData.fromDate,
      toDate: leaveFormData.applyForID == 2 ? null : leaveFormData.toDate,
      noOfDays: parseInt(leaveFormData.noOfDays),
      reason: leaveFormData.reason,
      isCoveringPerson: leaveFormData.isCoveringPerson,
      coveringPerson: leaveFormData.isCoveringPerson ? leaveFormData.coveringPerson : "",
      timeFrom: leaveFormData.timeFrom.toString(),
      timeTo: leaveFormData.timeTo.toString(),
      date: leaveFormData.applyForID == 1 ? null : leaveFormData.date,
      CreatedBy: parseInt(tokenService.getUserIDFromToken())
    }

    const response = await services.updateLeaveFormDetails(model);
    if (response.statusCode == "Success") {
      alert.success(response.message);
      clearData();
      navigate('/app/employeeLeaveForm/listing');
    }
    else {
      alert.error(response.message);
    }
  }

  async function handleRejectClick() {
    let model = {
      employeeLeaveRequestID: parseInt(atob(employeeLeaveRequestID)),
      registrationNumber: leaveFormData.regNo,
      ModifiedBy: parseInt(tokenService.getUserIDFromToken())
    }
    const response = await services.SaveRejectedLeaveRequest(model);
    if (response.statusCode == "Success") {
      alert.success(response.message);
      navigate('/app/employeeLeaveForm/listing');
    }
    else {
      alert.error(response.message);
    }
  }

  async function handleApproveClick() {
    let model = {
      employeeLeaveRequestID: parseInt(atob(employeeLeaveRequestID)),
      registrationNumber: leaveFormData.regNo,
      noOfDays: leaveFormData.noOfDays,
      leaveTypeID: leaveFormData.leaveTypeID,
      ModifiedBy: parseInt(tokenService.getUserIDFromToken())
    }
    const response = await services.SaveApprovedLeaveRequest(model);
    if (response.statusCode == "Success") {
      alert.success(response.message);
      navigate('/app/employeeLeaveForm/listing');
    }
    else {
      alert.error(response.message);
    }
  }

  function submitForm() {
    if (isUpdate == true) {
      trackPromise(updateEmployeeLeaveDetails());
    } else {
      trackPromise(submitApplication());
    }
  };

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setLeaveFormData({
      ...leaveFormData,
      [e.target.name]: value
    });
  }

  function isCoveringPersonHandleChange(e) {
    const target = e.target;
    const value = target.name === 'isCoveringPerson' ? target.checked : target.value

    setLeaveFormData({
      ...leaveFormData,
      [e.target.name]: value
    });
  };

  function clearData() {
    setLeaveFormData({
      ...leaveFormData,
      regNo: '',
      leaveTypeID: 0,
      fromDate: '',
      toDate: '',
      timeFrom: '',
      timeTo: '',
      date: '',
      noOfDays: 0,
      isCoveringPerson: false,
      coveringPerson: '',
      reason: '',
      applyForID: 0
    });
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: leaveFormData.groupID,
              factoryID: leaveFormData.factoryID,
              regNo: leaveFormData.regNo,
              leaveTypeID: leaveFormData.leaveTypeID,
              applyForID: leaveFormData.applyForID,
              fromDate: leaveFormData.fromDate,
              toDate: leaveFormData.toDate,
              date: leaveFormData.date,
              noOfDays: leaveFormData.noOfDays,
              timeTo: leaveFormData.timeTo,
              timeFrom: leaveFormData.timeFrom,
              reason: leaveFormData.reason,
              isCoveringPerson: leaveFormData.isCoveringPerson,
              coveringPerson: leaveFormData.coveringPerson,
              halfID: leaveFormData.halfID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                leaveTypeID: Yup.number().required('Leave Type is required').min("1", 'Leave Type is required'),
                applyForID: Yup.number().required('Applying for is required').min("1", 'Applying for is required'),
                fromDate: Yup.date().when('applyForID', { is: 1, then: Yup.date().required('From Date is required') }),
                toDate: Yup.date().when('applyForID', { is: 1, then: Yup.date().required('To Date is required') }),
                noOfDays: Yup.number()
                  .when('applyForID', {
                    is: 1,
                    then: Yup.number().min(1, 'No of days must be greater than zero').required('No of days is required'),
                    otherwise: Yup.number()
                  }),
                regNo: Yup.string().required('Registration No is required'),
                halfID: Yup.number().when('applyForID', { is: 2, then: Yup.number().required('Half type is required').min(1, 'Half type is required') }),
              })
            }
            onSubmit={submitForm}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Card style={{ padding: 30, marginTop: 20, marginBottom: 20 }}>
                          <Grid container spacing={3}>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="groupID">
                                Group *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.groupID && errors.groupID)}
                                fullWidth
                                helperText={touched.groupID && errors.groupID}
                                size='small'
                                name="groupID"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={leaveFormData.groupID}
                                variant="outlined"
                                id="groupID"
                                InputProps={{
                                  readOnly: isUpdate || !permissionList.isGroupFilterEnabled ? true : false
                                }}
                              >
                                <MenuItem value="0">--Select Group--</MenuItem>
                                {generateDropDownMenu(groups)}
                              </TextField>
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="factoryID">
                                Factory *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.factoryID && errors.factoryID)}
                                fullWidth
                                helperText={touched.factoryID && errors.factoryID}
                                size='small'
                                name="factoryID"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={leaveFormData.factoryID}
                                variant="outlined"
                                id="factoryID"
                                InputProps={{
                                  readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false
                                }}
                              >
                                <MenuItem value="0">--Select Factory--</MenuItem>
                                {generateDropDownMenu(factories)}
                              </TextField>
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="regNo">
                                Registration Number *
                              </InputLabel>
                              <TextField
                                error={Boolean(touched.regNo && errors.regNo)}
                                fullWidth
                                helperText={touched.regNo && errors.regNo}
                                size='small'
                                name="regNo"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={leaveFormData.regNo}
                                variant="outlined"
                                id="regNo"
                                InputProps={{
                                  readOnly: isUpdate ? true : false
                                }}
                              >
                              </TextField>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} style={{ marginBottom: 20 }}>
                            <Grid item md={4} xs={12} >
                              <InputLabel shrink id="leaveTypeID">
                                Leave Type *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.leaveTypeID && errors.leaveTypeID)}
                                fullWidth
                                helperText={touched.leaveTypeID && errors.leaveTypeID}
                                size='small'
                                name="leaveTypeID"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={leaveFormData.leaveTypeID}
                                disabled={!employeeVerified}
                                variant="outlined"
                                id="leaveTypeID"
                                InputProps={{
                                  readOnly: !permissionList.isLeaveRequestApproveReject ? true : false
                                }}
                              >
                                <MenuItem value="0">--Select Leave Type--</MenuItem>
                                {generateDropDownMenu(leaveTypes)}
                              </TextField>
                            </Grid>
                            <Grid item md={4} xs={12} >
                              <InputLabel shrink id="applyForID">
                                Apply For *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.applyForID && errors.applyForID)}
                                fullWidth
                                helperText={touched.applyForID && errors.applyForID}
                                size='small'
                                name="applyForID"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={leaveFormData.applyForID}
                                disabled={!employeeVerified}
                                variant="outlined"
                                id="applyForID"
                              >
                                <MenuItem value="0">--Select Apply For--</MenuItem>
                                <MenuItem value="1">Full Day</MenuItem>
                                <MenuItem value="2">Half Day</MenuItem>
                              </TextField>
                            </Grid>
                            {leaveFormData.applyForID == 2 ?
                              <Grid item md={4} xs={12} >
                                <InputLabel shrink id="halfID">
                                  Half Type *
                                </InputLabel>
                                <TextField select
                                  error={Boolean(touched.halfID && errors.halfID)}
                                  fullWidth
                                  helperText={touched.halfID && errors.halfID}
                                  size='small'
                                  name="halfID"
                                  onBlur={handleBlur}
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.halfID}
                                  disabled={!employeeVerified}
                                  variant="outlined"
                                  id="halfID"
                                >
                                  <MenuItem value="0">--Select Half --</MenuItem>
                                  <MenuItem value="1">Morning Half</MenuItem>
                                  <MenuItem value="2">Evening Half</MenuItem>
                                </TextField>
                              </Grid>
                              : null}
                          </Grid>
                          <Divider />
                          <Grid container spacing={3} style={{ marginTop: 20 }}>
                            {leaveFormData.applyForID == 2 ?
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="timeFrom">
                                  Time From
                                </InputLabel>
                                <TextField
                                  error={Boolean(touched.timeFrom && errors.timeFrom)}
                                  helperText={touched.timeFrom && errors.timeFrom}
                                  id="timeFrom"
                                  type="time"
                                  name="timeFrom"
                                  size='small'
                                  className={classes.textField}
                                  disabled={!employeeVerified}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    step: 300, // 5 min
                                    readOnly: true
                                  }}
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.timeFrom}
                                />
                              </Grid>
                              :
                              <Grid item md={4} xs={12} >
                                <InputLabel shrink id="fromDate">
                                  From Date *
                                </InputLabel>
                                <TextField
                                  error={Boolean(touched.fromDate && errors.fromDate)}
                                  fullWidth
                                  helperText={touched.fromDate && errors.fromDate}
                                  size='small'
                                  name="fromDate"
                                  type="date"
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.fromDate}
                                  disabled={!employeeVerified}
                                  variant="outlined"
                                  id="fromDate"
                                />
                              </Grid>
                            }
                            {leaveFormData.applyForID == 2 ?
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="timeTo">
                                  Time To
                                </InputLabel>
                                <TextField
                                  error={Boolean(touched.timeTo && errors.timeTo)}
                                  helperText={touched.timeTo && errors.timeTo}
                                  id="timeTo"
                                  type="time"
                                  name="timeTo"
                                  size='small'
                                  className={classes.textField}
                                  disabled={!employeeVerified}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    step: 300, // 5 min
                                    readOnly: true
                                  }}
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.timeTo}
                                />
                              </Grid>
                              :
                              <Grid item md={4} xs={12} >
                                <InputLabel shrink id="toDate">
                                  To Date *
                                </InputLabel>
                                <TextField
                                  error={Boolean(touched.toDate && errors.toDate)}
                                  fullWidth
                                  helperText={touched.toDate && errors.toDate}
                                  size='small'
                                  name="toDate"
                                  type="date"
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.toDate}
                                  disabled={!employeeVerified}
                                  variant="outlined"
                                  id="toDate"
                                />
                              </Grid>
                            }
                            {leaveFormData.applyForID == 0 || leaveFormData.applyForID == 1 ?
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="noOfDays">
                                  No Of Days *
                                </InputLabel>
                                <TextField
                                  error={Boolean(touched.noOfDays && errors.noOfDays)}
                                  fullWidth
                                  helperText={touched.noOfDays && errors.noOfDays}
                                  size='small'
                                  name="noOfDays"
                                  type='number'
                                  onBlur={handleBlur}
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.noOfDays}
                                  disabled={!employeeVerified}
                                  variant="outlined"
                                  id="noOfDays"
                                >
                                </TextField>
                              </Grid>
                              :
                              <Grid item md={4} xs={12} >
                                <InputLabel shrink id="date">
                                  Date *
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  size='small'
                                  name="date"
                                  type="date"
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.date}
                                  disabled={!employeeVerified}
                                  variant="outlined"
                                  id="date"
                                />
                              </Grid>}
                          </Grid>
                          <Grid container spacing={2} >
                            <Grid item md={8} xs={12}>
                              <InputLabel shrink id="reason">
                                Reason
                              </InputLabel>
                              <TextField
                                fullWidth
                                size='small'
                                name="reason"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={leaveFormData.reason}
                                disabled={!employeeVerified}
                                variant="outlined"
                                id="reason"
                                multiline
                                rows={3}
                              >
                              </TextField>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} >
                            <Grid item md={4} xs={12} >
                              <InputLabel shrink id="isCoveringPerson">
                                Is Recover Person
                              </InputLabel>
                              <Switch
                                checked={leaveFormData.isCoveringPerson}
                                size='small'
                                onChange={(e) => isCoveringPersonHandleChange(e)}
                                name="isCoveringPerson"
                                value={leaveFormData.isCoveringPerson}
                                disabled={!employeeVerified}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} >
                            {leaveFormData.isCoveringPerson === true ?
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="coveringPerson">
                                  Recovering Person
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  size='small'
                                  name="coveringPerson"
                                  onBlur={handleBlur}
                                  onChange={(e) => handleChange(e)}
                                  value={leaveFormData.coveringPerson}
                                  disabled={!employeeVerified}
                                  variant="outlined"
                                  id="coveringPerson"
                                >
                                </TextField>
                              </Grid>
                              : null}
                          </Grid>
                          {permissionList.isLeaveRequestApproveReject && isUpdate ?
                            <Grid item md={4} xs={12} style={{ marginTop: 20 }}>
                              <InputLabel shrink id="remainingLeave">
                                Remaining Leave Count
                              </InputLabel>
                              <TextField
                                size='small'
                                name="remainingLeave"
                                type='number'
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={remainingLeave}
                                disabled={!employeeVerified}
                                variant="outlined"
                                id="remainingLeave"
                                inputProps={{
                                  readOnly: true
                                }}
                              >
                              </TextField>
                            </Grid> : null}
                        </Card>
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        {!isUpdate ?
                          <Button
                            color="primary"
                            type="reset"
                            variant="outlined"
                            disabled={!employeeVerified}
                            onClick={() => clearData()}
                          >
                            Clear
                          </Button> : null}
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          disabled={!employeeVerified}
                          style={{ marginLeft: 10 }}
                        >
                          {isUpdate ? "Update" : "Send To Approve"}
                        </Button>
                        {permissionList.isLeaveRequestApproveReject && isUpdate ?
                          <Button
                            color="primary"
                            variant="contained"
                            style={{ marginLeft: 10 }}
                            className={classes.colorApprove}
                            onClick={handleApproveClick}
                          >
                            Approve
                          </Button>
                          : null}
                        {permissionList.isLeaveRequestApproveReject && isUpdate ?
                          <Button
                            color="primary"
                            variant="contained"
                            style={{ marginRight: '1rem', marginLeft: 10 }}
                            className={classes.colorReject}
                            onClick={handleRejectClick}
                          >
                            Reject
                          </Button>
                          : null}
                      </Box>

                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  )
}